import './Collaborators.css'
const Collaborators = (props) => {
    const redirect = () => {
        window.open(props.url)
    }
    return (
        <div className= 'collab-team' onClick={redirect}>
            <img src = {props.img} alt = 'logo'/>
        </div>
    )
}

export default Collaborators;